import { DebugConfigurationProviderTriggerKind } from '../vscode/vs/workbench/contrib/debug/common/debug.js';
import { getExtHostServices } from './extHost.js';
function create(getExtension) {
    return {
        get activeDebugSession() {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.activeDebugSession;
        },
        get activeDebugConsole() {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.activeDebugConsole;
        },
        get breakpoints() {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.breakpoints;
        },
        onDidStartDebugSession(listener, thisArg, disposables) {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.onDidStartDebugSession(listener, thisArg, disposables);
        },
        onDidTerminateDebugSession(listener, thisArg, disposables) {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.onDidTerminateDebugSession(listener, thisArg, disposables);
        },
        onDidChangeActiveDebugSession(listener, thisArg, disposables) {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.onDidChangeActiveDebugSession(listener, thisArg, disposables);
        },
        onDidReceiveDebugSessionCustomEvent(listener, thisArg, disposables) {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.onDidReceiveDebugSessionCustomEvent(listener, thisArg, disposables);
        },
        onDidChangeBreakpoints(listener, thisArgs, disposables) {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.onDidChangeBreakpoints(listener, thisArgs, disposables);
        },
        registerDebugConfigurationProvider(debugType, provider, triggerKind) {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.registerDebugConfigurationProvider(debugType, provider, triggerKind ?? DebugConfigurationProviderTriggerKind.Initial);
        },
        registerDebugAdapterDescriptorFactory(debugType, factory) {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.registerDebugAdapterDescriptorFactory(getExtension(), debugType, factory);
        },
        registerDebugAdapterTrackerFactory(debugType, factory) {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.registerDebugAdapterTrackerFactory(debugType, factory);
        },
        startDebugging(folder, nameOrConfig, parentSessionOrOptions) {
            const { extHostDebugService } = getExtHostServices();
            if ((parentSessionOrOptions == null) || (typeof parentSessionOrOptions === 'object' && 'configuration' in parentSessionOrOptions)) {
                return extHostDebugService.startDebugging(folder, nameOrConfig, { parentSession: parentSessionOrOptions });
            }
            return extHostDebugService.startDebugging(folder, nameOrConfig, parentSessionOrOptions);
        },
        stopDebugging(session) {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.stopDebugging(session);
        },
        addBreakpoints(breakpoints) {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.addBreakpoints(breakpoints);
        },
        removeBreakpoints(breakpoints) {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.removeBreakpoints(breakpoints);
        },
        asDebugSourceUri(source, session) {
            const { extHostDebugService } = getExtHostServices();
            return extHostDebugService.asDebugSourceUri(source, session);
        }
    };
}
export { create as default };
